import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('your_session_will_expire_in_time'),
    description: defineMessage('looks_like_you_are_inac__if_you_are_still_there'),
    continueButton: defineMessage('continue_working'),
};
